import { render, staticRenderFns } from "./RiskAssessmentImplementation.vue?vue&type=template&id=40a59c95&scoped=true&"
import script from "./RiskAssessmentImplementation.vue?vue&type=script&lang=js&"
export * from "./RiskAssessmentImplementation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a59c95",
  null
  
)

export default component.exports